import * as React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { User, Role } from "../../api/classes";
import { Select, MenuItem } from "@material-ui/core";
import { UpdateUserRequest } from "src/api/DubitoAPI";
import { DubitoSvc } from "src/api";
import { openSnack } from "src/util/util";

interface Props {
  open: boolean;
  element: User;
  roles: Role[];
  onCancel: () => void;
  onEdit: () => void;
}
export default class EditUser extends React.Component<Props> {
  state = {
    open: this.props.open,
    userEmail: this.props.element ? this.props.element.email : "",
    userName: this.props.element ? this.props.element.name : "",
    userPassword: "",
    userRole: this.props.element ? this.props.element.role_id : 0
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.onCancel && this.props.onCancel();
  };
  handleApprove = () => {
    if (this.props.element) {
      this.editUser();
    } else {
      this.addUser();
    }
  };
  addUser() {
    if (this.state.userEmail.length < 5 || this.state.userName.length < 3) {
      return;
    }
    DubitoSvc.addUser({
      email: this.state.userEmail,
      name: this.state.userName,
      password: this.state.userPassword,
      role_id: this.state.userRole
    })
      .then(() => {
        openSnack("User created!", "success");
        this.props.onEdit && this.props.onEdit();
      })
      .catch(() => {
        openSnack("User creation failed!", "error");
      });
  }
  editUser() {
    const updatedFields = {} as UpdateUserRequest;
    if (this.state.userEmail !== this.props.element.email) {
      updatedFields.email = this.state.userEmail;
    }
    if (this.state.userName !== this.props.element.name) {
      updatedFields.name = this.state.userName;
    }
    if (this.state.userRole !== this.props.element.role_id) {
      updatedFields.role_id = this.state.userRole;
    }
    if (this.state.userPassword.length > 0) {
      updatedFields.password = this.state.userPassword;
    }

    updatedFields.user_id = this.props.element.id;
    DubitoSvc.updateUser(updatedFields)
      .then(() => {
        openSnack("User updated succesfully!", "success");
        this.props.onEdit && this.props.onEdit();
      })
      .catch(() => {
        openSnack("User edit failed!", "error");
      });
  }
  componentWillReceiveProps(next: Props) {
    this.setState({
      open: next.open,
      userName: next.element ? next.element.name : "",
      userEmail: next.element ? next.element.email : "",
      userPassword: "",
      userRole: next.element ? next.element.role_id : 0
    });
  }
  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          style={{ minWidth: 500 }}
          maxWidth="sm"
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {this.props.element ? "Edit user" : "Add user"}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              value={this.state.userName}
              onChange={e => this.setState({ userName: e.target.value })}
              fullWidth
            />

            <TextField
              style={{ marginTop: 12 }}
              label="Role"
              select
              value={this.state.userRole}
              onChange={e => this.setState({ userRole: e.target.value })}
            >
              <MenuItem value={0}>
                <em>None</em>
              </MenuItem>
              {this.props.roles.map(r => (
                <MenuItem key={r.id} value={r.id}>
                  {r.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              style={{ marginTop: 12 }}
              autoFocus
              margin="dense"
              label="Email"
              value={this.state.userEmail}
              onChange={e => this.setState({ userEmail: e.target.value })}
              fullWidth
            />
            <TextField
              style={{ marginTop: 12 }}
              autoFocus
              margin="dense"
              label="Password"
              value={this.state.userPassword}
              onChange={e => this.setState({ userPassword: e.target.value })}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleApprove} color="primary">
              {this.props.element ? "Edit" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/edit.tsx